import React from 'react';

const TestPage = () => {
  console.log('🧪 TestPage component is rendering!');
  console.log('🧪 Current URL:', window.location.href);
  
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>🧪 Test Page - Visitor Route Working!</h1>
      <p>If you can see this page, the visitor routing is working correctly.</p>
      <p>Current URL: {window.location.href}</p>
      <p>Timestamp: {new Date().toISOString()}</p>
    </div>
  );
};

export default TestPage;
